import React from 'react';
import { connect, batch } from 'react-redux';

import {
    toggleIsFetchingNotificationsFlag,
    fetchNotifications,
    updateRoleTemplateNotifications
} from '../../actions';
import RoleTemplatesTable from '../common/RoleTemplatesTable';
import SearchFilter from '../common/SearchFilter';
import pushMessage from '../common/PushMessage';
import CONFIG from '../../config';

class RoleTemplatesNotifications extends React.Component {

    getFilterDropDown = (filterProps, dataIndex) => {
        const { setSelectedKeys, selectedKeys, confirm, clearFilters } = filterProps;
        return (
            <SearchFilter
                dataIndex={dataIndex}
                searchString={selectedKeys[0]}
                setSearchString={setSelectedKeys}
                confirm={confirm}
                handleClear={this.handleClear}
                handleSearch={this.handleFilter}
                clearFilters={clearFilters}
            />
        )
    }

    columnFilters = {
        filterDropdown: (filterProps) => this.getFilterDropDown(filterProps, "title"),
        sorter: true
    }

    filterSort = {}

    handleFilter = (title, confirm) => {
        title = title?.trim();
        if (!title && !this.filterSort.filter) {
            pushMessage(CONFIG.messageType.warning, "Please enter a search string")
            return;
        }
        else confirm()
    }

    handleClear = (clearFilters) => {
        clearFilters();
    }

    handleChange = (pagination, filters, sorter) => {

        this.filterSort = {
            filter: filters.title?.[0] ? { title: filters.title[0] } : undefined,
            sort: sorter.columnKey
                ? {
                    [sorter.columnKey]: CONFIG.sortMap[sorter.order]
                }
                : undefined
        }

        batch(() => {
            this.props.toggleIsFetchingNotificationsFlag(true);
            this.props.fetchNotifications({
                pageNumber: pagination.current,
                pageSize: (CONFIG.shortPageSize + 1),
                access: this.access,
                filterSort: this.filterSort
            });
        });
    }

    componentDidMount() {
        const { userRoleTemplate } = this.props;
        this.access = userRoleTemplate.templateType === CONFIG.roleTypes.admin ? CONFIG.roleTemplateAccess.fullAccess : undefined;
        this.props.toggleIsFetchingNotificationsFlag(true);
        this.props.fetchNotifications({ access: this.access });
    }

    render() {
        const { notifications, count, isFetching, assignedNotifications, allNotificationsUserAccess, allNotificationsAdminAccess, updateRoleTemplateNotifications, templateType } = this.props;
        return (
            <RoleTemplatesTable
                dataKey="notification"
                hideColumns={templateType === CONFIG.roleTypes.admin ? [] : ['admin']}
                marginTop={true}
                bordered={true}
                data={notifications}
                isFetching={isFetching}
                selectAllDisabled={this.filterSort.filter !== undefined}
                columnFilters={this.columnFilters}
                onChange={this.handleChange}
                pagination={{
                    pageSize: CONFIG.shortPageSize + 1,
                    total: count
                }}
                assignedData={assignedNotifications}
                allAdminAccess={allNotificationsAdminAccess}
                allUserAccess={allNotificationsUserAccess}
                updateRoleTemplateData={updateRoleTemplateNotifications}
            />
        );
    }
}

const mapStateToProps = ({ notifications, roleTemplate, user }) => {
    return {
        notifications: notifications.data,
        count: notifications.count,
        isFetching: notifications.isFetching,
        assignedNotifications: roleTemplate.notifications,
        allNotificationsUserAccess: roleTemplate.allNotificationsUserAccess,
        allNotificationsAdminAccess: roleTemplate.allNotificationsAdminAccess,
        templateType: roleTemplate.templateType,
        userRoleTemplate: user.profile ? user.profile.roleTemplate : undefined
    }
}

export default connect(
    mapStateToProps,
    {
        toggleIsFetchingNotificationsFlag,
        fetchNotifications,
        updateRoleTemplateNotifications
    }
)(RoleTemplatesNotifications);